import React from "react";
import HTMLContent from "../../../components/HTMLContent";

const ReturnAndRefundPolicy = ({ pageData }) => {
  return (
    <div className="privacy-policy">
      <section className="term-condition">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="text-center">
                <h1>Return & Refund Policy</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="innercontent-pages pt-4 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="card term-card mb-0">
                <div className="card-body">
                  <p>
                    At Siyora Jewels, we care about your shopping experience and want you to love every piece you buy from us. If you’re not fully satisfied with your purchase, we’re here to help.

                  </p>
                  <p>
                    <b>
                      Eligibility for Return

                    </b>
                  </p>
                  <p>
                    Returns can be requested within 7 days of receiving your order.

                  </p>
                  <p>
                    Items must be unused, unworn, and in their original packaging with all tags and certificates intact.

                  </p>
                  <p>
                    For hygiene reasons, earrings cannot be returned or exchanged unless received damaged or defective.

                  </p>
                  <p>
                    Customized or engraved jewellery is not eligible for return or refund.

                  </p>
                  <p><b>
                    How to Request a Return
                  </b></p>
                  <p>
                    Email us at [your support email] or WhatsApp us at [your WhatsApp number] within 7 days of delivery.
                  </p>
                  <p>
                    Share your order details and reason for return.

                  </p>
                  <p>
                    Once approved, you will receive return shipping instructions.

                  </p>
                  <p>
                    Securely pack the product in its original box and send it back.

                  </p>
                  <p>
                    (Return shipping cost may be borne by the customer unless the item is damaged or incorrect.)

                  </p>
                  <p>
                    <b>
                      Refund Process

                    </b>
                  </p>
                  <p>
                    After receiving and inspecting the returned item, we will notify you about your refund status.

                  </p>
                  <p>
                    Refunds will be processed to your original payment method within 5-7 working days after approval.

                  </p>
                  <p>
                    In case of COD orders, refunds will be issued to your bank account or UPI ID.

                  </p>
                  <p>
                    <b>
                      Damaged or Wrong Item Received

                    </b>
                  </p>
                  <p>
                    If you receive a defective or incorrect product, please inform us within 48 hours of delivery with unboxing photos/videos. We’ll arrange a replacement or full refund at no extra cost.

                  </p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReturnAndRefundPolicy;
